import { JSX, useContext } from "react";
import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";
import MegaMenuHeader from "@app/layout/menus/MegaMenuHeader";
import MegaMenuLink from "@app/layout/menus/MegaMenuLink";
import MegaMenuStandardLink from "@app/layout/menus/MegaMenuStandardLink";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";

const HelpMenu = (): JSX.Element => {
  const { enabledFeatureFlags } = useContext(FeatureFlagContext);
  const uri = enabledFeatureFlags.has(Features.QES_USER_GUIDE_SFTP)
    ? "https://devstqesuserguidew.z22.web.core.windows.net/"
    : "https://questanalytics.gtmbuddy.io/shares/view/room/view/6880d01062bf7c149e2edf5c?pageId=68dd53a3c7cc1f4132f487ca#1dc0c7c667d243978a8a095d67e84ad1";
  const title = "QES User Guide";
  
  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Help" />
        <ul className="menu">
          <MegaMenuStandardLink faIcon="phone" to={`https://questanalytics.com/contact/`} linkText="Contact Us"
            menuItem={MenuItemEnum.ContactUs} />
          <RoleRestricted allowedRoles={[Roles.VIEWER, Roles.QUEST_USER, Roles.QUEST_ADMIN]}>
            <MegaMenuStandardLink faIcon="book" to={uri} linkText={title} target="_blank"
              menuItem={MenuItemEnum.QesUserGuide} testId="help-menu__qes-user-guide-link" />
          </RoleRestricted>
          <MegaMenuLink faIcon="file-pdf-o" menuItem={MenuItemEnum.QESTutorial} to="/tutorials/qes"
            linkText="QES Tutorials" />
          <RoleRestricted allowedRoles={[Roles.SOFTWARE_LICENSE]}>
            <MegaMenuLink faIcon="file-pdf-o" menuItem={MenuItemEnum.DesktopTutorial} to="/tutorials/qas"
              linkText="QAS Tutorials" />
          </RoleRestricted>
        </ul>
      </li>
    </ul>
  );
};

export default HelpMenu;
